import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SEOHead from '../components/SEOHead';
import { BreadcrumbSchema } from '../components/StructuredData';
import LoginForm from '../components/LoginForm';

const LoginPage: React.FC = () => {
  return (
    <>
      <SEOHead
        title="Login - Anmelden"
        description="Melden Sie sich an, um auf Ihren EU AI Act Kompetenznachweis-Kurs zuzugreifen und Ihre Schulung fortzusetzen."
        keywords={['Login', 'Anmelden', 'Kurs-Zugang', 'EU AI Act Login']}
        canonicalUrl="/login"
        noIndex={true}
      />
      <BreadcrumbSchema items={[
        { name: 'Startseite', url: '/' },
        { name: 'Login', url: '/login' }
      ]} />
      <div className="min-h-screen bg-gray-50 pt-24 pb-12">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto mb-8">
            <Link
              to="/"
              className="inline-flex items-center text-gray-700 hover:text-gray-900 transition-colors group"
            >
              <ArrowLeft className="h-5 w-5 mr-2 group-hover:-translate-x-1 transition-transform" />
              <span className="font-medium">Zurück zur Startseite</span>
            </Link>
          </div>

          <h1 className="text-3xl font-bold text-center text-gray-900 mb-8">
            Willkommen zurück
          </h1>

          <LoginForm />
        </div>
      </div>
    </>
  );
};

export default LoginPage;